import PropTypes from "prop-types"
import React from "react"
import { connect, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { useDispatch } from "react-redux"
import withRouter from "../Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import logoSm from "../../assets/images/logo-sm.svg"
import logoDark from "../../assets/images/logo.svg"
import logoLight from "../../assets/images/logo-light.png"
import burger from "../../assets/images/burger.svg"

import { changeSidebarSize } from "../../store/actions"

const Sidebar = props => {
  const dispatch = useDispatch()
  function tToggle() {
    var body = document.body
    var windowSize = document.documentElement.clientWidth

    body.classList.toggle("vertical-collpsed")
    body.classList.toggle("sidebar-enable")
    dispatch(changeSidebarSize("sm"))
    if (windowSize > 991) {
      body.getAttribute("data-sidebar-size") === "sm"
        ? body.setAttribute("data-sidebar-size", "lg")
        : body.setAttribute("data-sidebar-size", "sm")
    }
  }

  const loggedUser = useSelector(state => state.Login.loggedUser)

  const imgUrl = process.env.REACT_APP_IMG_APIKEY

  // useEffect(() => {
  //   // var verticalOverlay = document.getElementsByClassName("vertical-overlay");
  //   if (document.body.classList.contains("vertical-collpsed") && document.body.classList.contains("sidebar-enable")) {
  //     // verticalOverlay[0].addEventListener("click", function () {
  //       document.body.classList.remove("vertical-collpsed");
  //       document.body.classList.remove("sidebar-enable");

  //     };
  //   // }
  // });

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm text-center">
              {!loggedUser?.settings && !loggedUser?.settings?.mob_svg ? (
                <>
                  <div className="d-flex justify-content-center align-items-center header-logo mt-3">
                    <div className="skeleton skeleton-text"></div>
                  </div>
                </>
              ) : (
                <>
                  {loggedUser?.settings?.mob_svg ? (
                    <img
                      className=""
                      src={`${imgUrl}${loggedUser?.settings?.mob_svg}`}
                      alt=""
                      height="40"
                    />
                  ) : (
                    <img className="" src={logoSm} alt="" height="22" />
                  )}
                </>
              )}
            </span>
            <span className="logo-lg">
              {!loggedUser?.settings && !loggedUser?.settings?.companylogo ? (
                <>
                  <div className="d-flex justify-content-center align-items-center header-logo mt-3">
                    <div className="skeleton skeleton-text"></div>
                  </div>
                </>
              ) : (
                <>
                  {loggedUser?.settings?.companylogo ? (
                    <img
                      className="header-logo"
                      src={`${imgUrl}${loggedUser?.settings?.companylogo}`}
                      alt=""
                      height="40"
                    />
                  ) : (
                    <img
                      className="header-logo"
                      src={logoDark}
                      alt=""
                      height="40"
                    />
                  )}
                </>
              )}
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm text-center">
              <img src={logoSm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="" height="20" />
            </span>
          </Link>
        </div>
        <button
          onClick={() => {
            tToggle()
          }}
          type="button"
          className="btn btn-sm font-size-16 header-item waves-effect vertical-menu-btn"
        >
          <img src={burger} alt="" width="24" />
        </button>
        <div className="sidebar-menu-scroll">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
  changeSidebarSize: PropTypes.func,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
